export default __webpack_public_path__ + "fonts/BebasNeue-Bold.woff2";